export default "/assets/images/performance-filter-img-02.png?b1dd2402b28ed3de5b1e3ac742aea1d2";